export async function fetchData(page: number = 1, itemsPerPage: number, search: string = '', filters: {}) {
  const offset = (page - 1) * itemsPerPage;
  const filterParams = Object.entries(filters)
    .filter(([_, value]) => value === true)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
  try {
    const response = await fetch(`https://api.spaceflightnewsapi.net/v4/articles/?limit=${itemsPerPage}&offset=${offset}&search=${search}&${filterParams}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}
